import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetDeviceCodeList: false,
  getDeviceCodeListMessage: '',
  getDeviceCodeListFailed: '',

  isLoadingGetDisuseDeviceCode: false,
  getDisuseDeviceCodeMessage: '',
  getDisuseDeviceCodeFailed: '',

  isLoadingPostCreateDeviceCode: false,
  postCreateDeviceCodeMessage: '',
  postCreateDeviceCodeFailed: '',

  isLoadingDeleteDeviceCode: false,
  deleteDeviceCodeMessage: '',
  deleteDeviceCodeFailed: '',

  isLoadingUpdateDeviceCodeName: false,
  updateDeviceCodeNameMessage: '',
  updateDeviceCodeNameFailed: '',
};

const initialState = JSON.parse(JSON.stringify(state));

function deviceCodeReducer(globalstate = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initialState,
      };
    case actionTypes.GET_DEVICE_CODE_LIST_PENDING:
      return {
        ...globalstate,
        isLoadingGetDeviceCodeList: true,
      };
    case actionTypes.GET_DEVICE_CODE_LIST_FULFILLED:
      return {
        ...globalstate,
        isLoadingGetDeviceCodeList: false,
        getDeviceCodeListMessage: action.data,
        getDeviceCodeListFailed: '',
      };
    case actionTypes.GET_DEVICE_CODE_LIST_FAILURE:
      return {
        ...globalstate,
        isLoadingGetDeviceCodeList: false,
        getDeviceCodeListMessage: '',
        getDeviceCodeListFailed: action.error,
      };
    case actionTypes.GET_DISUSE_DEVICE_CODE_PENDING:
      return {
        ...globalstate,
        isLoadingGetDisuseDeviceCode: true,
      };
    case actionTypes.GET_DISUSE_DEVICE_CODE_FULFILLED:
      return {
        ...globalstate,
        isLoadingGetDisuseDeviceCode: false,
        getDisuseDeviceCodeMessage: action.data,
        getDisuseDeviceCodeFailed: '',
      };
    case actionTypes.GET_DISUSE_DEVICE_CODE_FAILURE:
      return {
        ...globalstate,
        isLoadingGetDisuseDeviceCode: false,
        getDisuseDeviceCodeMessage: '',
        getDisuseDeviceCodeFailed: action.error,
      };
    case actionTypes.POST_CREATE_DEVICE_CODE_PENDING:
      return {
        ...globalstate,
        isLoadingPostCreateDeviceCode: true,
      };
    case actionTypes.POST_CREATE_DEVICE_CODE_FULFILLED:
      return {
        ...globalstate,
        isLoadingPostCreateDeviceCode: false,
        postCreateDeviceCodeMessage: action.data,
        postCreateDeviceCodeFailed: '',
      };
    case actionTypes.POST_CREATE_DEVICE_CODE_FAILURE:
      return {
        ...globalstate,
        isLoadingPostCreateDeviceCode: false,
        postCreateDeviceCodeMessage: '',
        postCreateDeviceCodeFailed: action.error,
      };
    case actionTypes.DELETE_DEVICE_CODE_PENDING:
      return {
        ...globalstate,
        isLoadingDeleteDeviceCode: true,
      };
    case actionTypes.DELETE_DEVICE_CODE_FULFILLED:
      return {
        ...globalstate,
        isLoadingDeleteDeviceCode: false,
        deleteDeviceCodeMessage: action.data,
        deleteDeviceCodeFailed: '',
      };
    case actionTypes.DELETE_DEVICE_CODE_FAILURE:
      return {
        ...globalstate,
        isLoadingDeleteDeviceCode: false,
        deleteDeviceCodeMessage: '',
        deleteDeviceCodeFailed: action.error,
      };
    case actionTypes.UPDATE_DEVICE_CODE_NAME_PENDING:
      return {
        ...globalstate,
        isLoadingUpdateDeviceCodeName: true,
      };
    case actionTypes.UPDATE_DEVICE_CODE_NAME_FULFILLED:
      return {
        ...globalstate,
        isLoadingUpdateDeviceCodeName: false,
        updateDeviceCodeNameMessage: action.data,
        updateDeviceCodeNameFailed: '',
      };
    case actionTypes.UPDATE_DEVICE_CODE_NAME_FAILURE:
      return {
        ...globalstate,
        isLoadingUpdateDeviceCodeName: false,
        updateDeviceCodeNameMessage: '',
        updateDeviceCodeNameFailed: action.error,
      };

    default:
      return globalstate;
  }
}

export { deviceCodeReducer as default };
